import clsx from 'clsx'

export const InfoAlert = ({
  variant = 'info',
  title,
  children,
  className = '',
}: InfoAlertProps) => {
  const variantStyles = [
    {
      key: 'info',
      bg: 'bg-gradient-to-br from-blue-50 to-indigo-50',
      border: 'border-blue-500',
      text: 'text-blue-700',
      titleText: 'text-gray-900',
    },
    {
      key: 'success',
      bg: 'bg-gradient-to-br from-green-50 to-emerald-50',
      border: 'border-green-500',
      text: 'text-green-700',
      titleText: 'text-gray-900',
    },
    {
      key: 'warning',
      bg: 'bg-gradient-to-br from-amber-50 to-orange-50',
      border: 'border-amber-500',
      text: 'text-amber-700',
      titleText: 'text-gray-900',
    },
    {
      key: 'error',
      bg: 'bg-gradient-to-br from-red-50 to-rose-50',
      border: 'border-red-500',
      text: 'text-red-700',
      titleText: 'text-gray-900',
    },
  ]

  const variantStyle = variantStyles.find(style => style.key === variant)
  if (!variantStyle) return null

  return (
    <div
      className={clsx(
        'rounded-lg shadow-sm mb-6 transition-all duration-200 border-l-4',
        'hover:shadow-md',
        variantStyle.bg,
        variantStyle.border,
        className
      )}
    >
      <div className="p-4">
        {title && (
          <div
            className={clsx('font-bold text-xl mb-2', variantStyle.titleText)}
          >
            {title}
          </div>
        )}
        <div className={clsx('text-base', variantStyle.text)}>{children}</div>
      </div>
    </div>
  )
}

interface InfoAlertProps {
  variant?: string
  title?: string
  children: React.ReactNode
  className?: string
}
